import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ActivityService } from 'app/services/activity.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';

export interface QcLayerSelectModalInput {
	layers: LayerItem[];
}

interface LayerItem {
	label: string;
	id;
	selected?: boolean;
}

@Component({
  selector: 'app-qc-layer-select-modal',
  templateUrl: './qc-layer-select-modal.component.html',
  styleUrls: ['./qc-layer-select-modal.component.css']
})
export class QcLayerSelectModalComponent implements OnInit {


	// selectedLayer: LayerItem;
	layers: LayerItem[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: QcLayerSelectModalInput,
		private dialogRef: MatDialogRef<QcLayerSelectModalComponent>,
		private activityService: ActivityService,
		private mainDataService: MainDataService,
		private qcService: LayerQcService
	) { }

	cancel() {
		this.dialogRef.close();
	}
	runQc() {
		const selectedLayers = this.layers.filter(l => l.selected);
		if (!selectedLayers.length) {
			return;
		}
		const rules = null; // this.mainDataService.getQaCodesFromFilterOptions();
		this.qcService.qcLayers(selectedLayers.map(l => l.id), null, rules);
		this.dialogRef.close();		
	}

	disableQc = () => {
		return !this.layers.find(l => l.selected);
	}

	ngOnInit() {
		this.layers = this.data.layers;
		const selectedLayer = this.layers.find(l => l.id === this.activityService.selectedLayerBS.getValue().layer.id);
		if (selectedLayer) {
			selectedLayer.selected = true;
		}
	}

}
